import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './style.css';

const ContentSurface = ({ as: Component, children, className }) => {
  return (
    <Component className={clsx('content-surface', className)}>
      {children}
    </Component>
  );
};

ContentSurface.defaultProps = {
  as: 'div',
};

ContentSurface.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ContentSurface;
